export default __webpack_public_path__ + "static/media/ME.41e75813.svg";